export enum TokenStatusEnum {
  ACTIVE = 'ACTIVE',
  END_OF_LIVE = 'END_OF_LIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  NULL = 'NULL',
}
